exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-component .no-backgroud{background:none !important}.message-component .break-line{overflow:hidden;text-overflow:ellipsis;word-wrap:break-word}\n", ""]);

// exports
